<template>
  <div>
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <div style="text-align: center;font-size: 20px;">
      <button
        style="width:500px;height:100px;background-color:orange;margin:auto"
        @click="print()"
      >
        طباعة تقرير مبيعات صنف بالمندوب من الي
        <br />
        {{ $route.query.name }}
      </button>
    </div>
    <div id="printMe" style="display:none">
      <div style="direction:rtl;float:right">
        <p
          style="text-align:center;font-size:22px;font-weight:bold;margin-bottom:15px;text-decoration:underline;"
        >
          تقرير مبيعات صنف بالمندوب {{ $route.query.name }} من الي
          {{ $route.query.from }} الي
          {{ $route.query.to }}
        </p>
        <div class="row">
          <div class="col-sm-4" style="border-left:1px dotted">
            <div style="float:right;">
              <img
                style="width:100%;height:100px;"
                src="../../../../public/images/pharma_logo.jpg"
                alt="Pharma"
              />
            </div>
          </div>
          <div class="col-sm-8">
            <div style="float:right;font-size:17px;text-align:right">
              <p>
                <span style="font-weight:bold;"> المجموع : </span>
                <span> {{ all_of_total }} </span>
              </p>
              <p>
                <span style="font-weight:bold;">العمولات : </span>
                <span> {{ omola_total }} </span>
              </p>
              <p>
                <span style="font-weight:bold;">عدد الفواتير: </span>
                <span> {{ count_of_count }} </span>
              </p>
            </div>
          </div>
        </div>
        <hr />
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">الكود</th>
              <th scope="col">اسم العميل</th>
              <th scope="col">عدد الفواتير</th>
              <th scope="col">مجموع الفواتير</th>
              <th scope="col">عمولة</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas" :key="f.id">
              <th scope="row">{{ f.code }}</th>
              <td>{{ f.name }}</td>
              <td>{{ f.count }}</td>
              <td>{{ f.total }}</td>
              <td>{{ f.omola }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { MandobItemReport } from "../../config/apiRoute.js";
import { appUrl } from "../../config/apiConfig.js";
export default {
  data() {
    return {
      loading: true,
      fatworas: [],

      all_of_total: "",
      count_of_count: "",
      omola_total: "",
      appUrl: ""
    };
  },
  mounted() {
    this.appUrl = appUrl;
    this.get_data();
  },
  methods: {
    print() {
      this.$htmlToPaper("printMe");
    },
    get_data() {
      var frmData = new FormData();
      frmData.append("mandob_id", this.$route.query.id);
      frmData.append("item_id", this.$route.query.item_id);
      frmData.append("date_from", this.$route.query.from);
      frmData.append("date_to", this.$route.query.to);
      MandobItemReport(frmData).then(response => {
        response.data.myarr.length > 0
          ? (this.fatworas = response.data.myarr)
          : (this.fatworas = []);
        this.all_of_total = response.data.all_of_total;
        this.count_of_count = response.data.count_of_count;
        this.omola_total = response.data.omola_total;

        this.loading = false;
        setTimeout(() => {
          this.print();
        }, 200);
      });
    }
  }
};
</script>
